export default __webpack_public_path__ + "static/media/second_section_b.3558cd5e.png";